module.exports = __webpack_public_path__ + "static/dietrich-504e366773355dbb8b01d5cd742f087f.png";